import { carouselDataType } from './actionTypes';

export const fetchCarouselData = payload => ({
  type: carouselDataType,
  payload
});
